import { inventoryLocalization, formatMileage, formatPrice } from '../translations';

export function isNumeric(searchParam) {
  return ['year', 'price', 'odometer'].includes(searchParam);
}

export function addUnits(searchParam, value, tags = ['filter']) {
  switch (searchParam) {
    case 'price':
      return formatPrice(value, tags);
    case 'odometer':
      return formatMileage(value, tags);
    case 'year':
      return value;
    default:
      return value;
  }
}

/**
 * Function to add text to the slider tooltip
 * @param {String} searchParam Slider serach paramater
 * @param {Object} options     noUiSlider options object
 * @param {Number} minValue    min value selected by user
 * @param {Number} maxValue    max value selected by user
 * @return {String}            slider tooltip text
 */
export function sliderText(searchParam, options, minValue, maxValue) {
  const formatterTags = ['filter', 'slider'];
  minValue = parseInt(minValue);
  maxValue = parseInt(maxValue);

  if (minValue == options.range.min && maxValue < options.range.max) {
    return 'Up to ' + addUnits(searchParam, maxValue, formatterTags);
  } else if (minValue > options.range.min && maxValue == options.range.max) {
    return (
      addUnits(searchParam, minValue, formatterTags) + ` ${inventoryLocalization.xgettext('and up', 'range')}`
    );
  } else if (minValue > options.range.min && maxValue < options.range.max) {
    return (
      addUnits(searchParam, minValue, formatterTags) +
      ` ${inventoryLocalization.xgettext('to', 'range')} ` +
      addUnits(searchParam, maxValue, formatterTags)
    );
  }

  return 'No minimum or maximum';
}

/**
 *
 * @param {HTMLElement} filter filter container
 * @param {String} searchParam search parameter
 * @param {Object} inventory   inventory
 * @return {Object}            object with available options for this search parameter
 */
export function findOptions(filter, searchParam, inventory) {
  if (!isNumeric(searchParam)) {
    return inventory[searchParam];
  }

  const options = {
    minValue: 0,
    maxValue: 0,
    step: parseInt(filter.getAttribute('data-step')),
  };

  switch (searchParam) {
    case 'year':
      options.minValue = inventory.minYear;
      options.maxValue = inventory.maxYear;
      break;

    case 'odometer':
      options.minValue = 0;
      options.maxValue =
        inventory.odometer && inventory.odometer.length > 0
          ? inventory.odometer[inventory.odometer.length - 1].value
          : 1000000;
      options.format = formatMileage;
      break;

    case 'price':
      options.minValue = inventory?.price?.min ?? 0;
      options.maxValue = inventory?.price?.max ?? 100000; // ?
      options.format = formatPrice;
      break;
  }

  return options;
}

export function getParametersFromUrl(url) {
  const _url = new URL(url);

  const _params = {};
  _url.searchParams.forEach((value, key) => {
    _params[key.replace('dsp_', '')] = value;
  });

  return _params;
}
